import { useEffect, useState } from 'react';

export function useAsyncLoader(load, ...args){
  const [state, setState] = useState({
    isLoading: true,
    data: null,
    error: null,
  });

  useEffect(() => {
    let isCurrent = true;

    async function execute() {
      try {
        setState(oldState => ({ isLoading: true, data: oldState.data, error: null }));
        const data = await load(...args);

        if (isCurrent) {
          setState({ isLoading: false, data, error: null });
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line
          console.error(error);
        }

        if (isCurrent) {
          setState({ isLoading: false, data: null, error });
        }
      }
    }

    execute();

    return () => {
      isCurrent = false;
    };
  }, [...args, load]); // eslint-disable-line

  return state;
}
